// CTA画像のモバイル切り替え
document.addEventListener('DOMContentLoaded', function() {
  const config = window.aseaveConfig || {};
  const mobileSources = [];

  if (config.mobileCTAImage) {
    mobileSources.push(config.mobileCTAImage);
  }

  if (Array.isArray(config.mobileCTAImageAlt)) {
    config.mobileCTAImageAlt.forEach(function(url) {
      if (url && !mobileSources.includes(url)) {
        mobileSources.push(url);
      }
    });
  }

  if (!mobileSources.length) {
    return;
  }

  const newsBody = document.querySelector('.news-detail-body');
  if (!newsBody) {
    return;
  }

  const CTA_MIN_WIDTH = 400;
  const CTA_MAX_HEIGHT = 180;
  const CTA_ASPECT_THRESHOLD = 4;

  const qualifyImage = function(img) {
    if (img.classList.contains('desktop-cta-image')) {
      return true;
    }

    const naturalWidth = img.naturalWidth || 0;
    const naturalHeight = img.naturalHeight || 0;

    if (!naturalWidth || !naturalHeight) {
      return false;
    }

    const aspect = naturalWidth / naturalHeight;

    return naturalWidth >= CTA_MIN_WIDTH &&
      naturalHeight <= CTA_MAX_HEIGHT &&
      aspect >= CTA_ASPECT_THRESHOLD;
  };

  const applyMobileVariant = function(img) {
    if (!qualifyImage(img)) {
      return;
    }

    const link = img.closest('a');
    if (!link) {
      return;
    }

    img.classList.add('desktop-cta-image');

    if (link.querySelector('img.mobile-cta-image')) {
      return;
    }

    const mobileImg = document.createElement('img');
    mobileImg.classList.add('mobile-cta-image');
    mobileImg.alt = img.alt || '';
    mobileImg.decoding = 'async';
    mobileImg.loading = img.loading || 'lazy';

    let sourceIndex = 0;

    const setNextSource = function() {
      if (sourceIndex >= mobileSources.length) {
        return;
      }
      mobileImg.src = mobileSources[sourceIndex];
      sourceIndex += 1;
    };

    mobileImg.addEventListener('error', function() {
      setNextSource();
    });

    setNextSource();

    link.appendChild(mobileImg);
  };

  const ctaCandidates = newsBody.querySelectorAll('a img');

  ctaCandidates.forEach(function(img) {
    if (img.complete) {
      applyMobileVariant(img);
    } else {
      img.addEventListener('load', function handleLoad() {
        img.removeEventListener('load', handleLoad);
        applyMobileVariant(img);
      });
    }
  });
});
